// @flow

import {closestIndex} from './closestIndex';

type Params = {|
    rowsOffset: Array<number>,
    scrollOffset: number,
    overscanRows?: number,
    viewportHeight?: number,
|};

export const calcRowEndIndex = ({scrollOffset, viewportHeight, overscanRows, rowsOffset}: Params): number => (
    closestIndex(scrollOffset + viewportHeight, rowsOffset) + overscanRows
);
